import { useWindowTitleUpdater } from '../hooks/useWindowTitleUpdater';

export const WindowTitleUpdater = () => {
  useWindowTitleUpdater();
  return null;
};
